const base = '/v2/admin'
const permMap = {}
const exMap = {
  'POST /v2/admin/casbin': true,
  'GET /v2/admin/casbin/routes': true,
  'GET /v2/admin/editlog': true,
  'GET /v2/admin/editlog/:id': true,
  'GET /v2/admin/goog-login': true,
  'GET /v2/admin/goog-auth': true,
  'GET /v2/admin/hideid/hide/:id': true,
  'GET /v2/admin/hideid/unhide/:id': true,
  'GET /v2/admin/me': true,
  'GET /v2/admin/me/perm': true,
  'PUT /v2/admin/me/metabase_token': true,
  'OPTIONS /v2/admin/*cors': true,
  'POST /v2/admin/password/recover': true,
  'POST /v2/admin/password/reset': true,
  'POST /v2/admin/password/change': true,
  'POST /v2/admin/opencc': true,
  'POST /v2/admin/login': true,
  'POST /v2/admin/login/mfa': true,
  'POST /v2/admin/logout': true,
  'POST /v2/admin/token/zendesk': true
}

export const basePath = base

export function isExPath (key) {
  return exMap.hasOwnProperty(key)
}

export function getRefPath () {
  return {
    '/merchant/branch/add': [
      '/merchant/contact',
      '/merchant/partner',
      'GET /v2/admin/region',
      'GET /v2/admin/brand',
      'GET /v2/admin/industry',
      'GET /v2/admin/language'
    ],
    '/merchant/branch/edit': [
      '/merchant/contact',
      '/merchant/partner',
      'GET /v2/admin/region',
      'GET /v2/admin/brand',
      'GET /v2/admin/industry',
      'GET /v2/admin/language'
    ],
    '/merchant/merchant/add': [
      '/merchant/contact'
    ],
    '/merchant/merchant/edit': [
      '/merchant/contact'
    ],
    '/merchant/product/add': [
      '/merchant/partner',
      'GET /v2/admin/region'
    ],
    '/merchant/product/edit': [
      '/merchant/partner',
      'GET /v2/admin/region'
    ]
  }
}

export function getPermMap () {
  // user
  initAdminUser('/user/admin/admin_user', '/user/admin')
  initStatus('/user/admin/admin_role', '/user/admin/role')
  initManager('/user/manager', '/user/bossnow')
  initList('/user/allmember', '/user/member')
  initMember('/user/member/funnow', '/user/funnow')
  initMember('/user/member/niceday', '/user/niceday')
  initMember('/user/member/eatigo', '/user/eatigo')
  initCRUD('/user/member/mbrtag', '/mbrtag')
  initCRUD('/user/member/blacklist', '/blacklist')
  initCRUD('/user/dlvaddress', '/dlvaddress')

  // region
  initRegion('/region/region', '/region')
  initCategory('/region/category/category', '/category')
  initFilter('/region/category/filter', '/filter')
  initTag('/region/tag/prodtag', '/prodtag')
  initCRUD('/region/tag/prodtag_group', '/prodtag_group')
  initCRUD('/region/tag/prodtag_uniqtag', '/prodtag_uniqtag')
  initBanner('/region/banner', '/banner')
  initEventNews('/region/eventnews', '/eventnews')
  initHotSearch('/region/hotsearch', '/hotsearch')
  initStatus('/region/dlvarea', '/dlvarea')
  initCRUD('/region/title', '/title')

  // merchant
  initMerchant('/merchant/merchant', '/merchant')
  initBranch('/merchant/branch', '/branch')
  initList('/merchant/aos_forms', '/aos/branch/form')
  initCRUD('/merchant/contact', '/contact')
  initProduct('/merchant/product', '/product')
  initPartner('/merchant/partner', '/partner')
  initUpgrade('/merchant/upgrade', '/product_upgrade')
  initCRUD('/merchant/resource/resource_group', '/resource_group')
  initStatus('/merchant/resource/resource', '/resource')
  initRemark('/merchant/remark/remark', '/product_remark')
  initCRUD('/merchant/remark/remark_group', '/remark_group')

  // orders
  initOrders('/orders/orders', '/orders')
  initView('/orders/reservation', '/reservation')
  initView('/orders/refund', '/refund')
  initInvoice('/orders/invoice', '/invoice')
  initReceipt('/orders/orders_receipt', '/orders_receipt')

  // gift
  initGiftCard('/gift/giftcard', '/giftcard')
  initView('/gift/gift', '/gift')

  // chart
  initPayment('/chart/payment', '/payment')
  initPaymentBrand('/chart/payment_brand', '/payment_brand')
  initPaymentSet('/chart/payment_set', '/payment_set')
  initStatement('/chart/statement/statement', '/statement')
  initStatementEmail('/chart/statement/statement_email', '/statement_email')
  initStatementOrdersSet('/chart/statement/statement_orders_set', '/statement_orders_set')
  initStatementOrders('/chart/statement/statement_orders', '/statement_orders')
  initStatementOrdersBrand('/chart/statement/statement_orders_brand', '/statement_orders_brand')
  initExport('/chart/export', '/export')
  initCRUD('/chart/contract', '/contract')
  initChannel('/chart/channel', '/channel')
  initSOAInvoice('/chart/soa/invoice', '/soa/invoice')
  initSOANote('/chart/soa/note', '/soa/note')
  initSOAReceipt('/chart/soa/receipt', '/soa/receipt')
  initSOAEmail('/chart/soa/email', '/soa/email')

  // message
  initNews('/message/news', '/news')

  // web
  initBlog('/web/blog/blog_article', '/blog')
  initBlogAuthor('/web/blog/blog_author', '/blog_author')
  initBlogCountry('/web/blog/blog_country', '/blog_country')
  initBlogCategory('/web/blog/blog_category', '/blog_category')
  initCRUD('/web/blog/blog_tag', '/blog_tag')
  initStatus('/web/help', '/help')

  // event
  initPromo('/event/promo', '/promo')
  initCampaign('/event/campaign', '/campaign')
  initPromoCampaign('/event/promo_campaign', '/promo_campaign')
  initMemberMission('/event/member_mission', '/member_mission')
  initTask('/event/task', '/task')

  // setting
  initTemplate('/setting/template', '/template')
  initCRUD('/setting/language', '/language')
  initCurrency('/setting/currency', '/currency')
  initCRUD('/setting/brand/brand', '/brand')
  initCRUD('/setting/brand/brand_field', '/brand_field')
  initCRUD('/setting/industry', '/industry')

  return permMap
}

const viewPath = (path) => {
  return path + '/view'
}

const sendPath = (path) => {
  return path + '/send'
}

const editPath = (path) => {
  return path + '/edit'
}

const addPath = (path) => {
  return path + '/add'
}

const deletePath = (path) => {
  return path + '/delete'
}

const initPartner = (path, apiPath) => {
  permMap[path] = [
    'view'
  ]
  permMap[viewPath(path)] = [
    {
      'path': 'GET ' + base + apiPath
    }
  ]
}

const initChannel = (path, apiPath) => {
  initCRUD(path, apiPath)
  let view = viewPath(path)
  permMap[view] = [...permMap[view],
    {
      'path': 'GET ' + base + '/orders/refer'
    }
  ]
}

const initTemplate = (path, apiPath) => {
  initCRUD(path, apiPath)
  let edit = editPath(path)
  permMap[edit] = [...permMap[edit],
    {
      'path': 'POST ' + base + apiPath + '/album_image'
    }
  ]
}

const initExport = (path, apiPath) => {
  permMap[path] = [
    'view',
    'delete'
  ]
  permMap[viewPath(path)] = [
    {
      'path': 'GET ' + base + apiPath
    }, {
      'path': 'GET ' + base + apiPath + '/:id'
    }
  ]
  permMap[deletePath(path)] = [
    {
      'path': 'DELETE ' + base + apiPath + '/:id'
    }
  ]
}

const initPayment = (path, apiPath) => {
  initEdit(path, apiPath)
  addExport(path, apiPath)
  let edit = editPath(path)
  permMap[edit] = [...permMap[edit],
    {
      'path': 'POST ' + base + apiPath + '/refresh/:id'
    }, {
      'path': 'POST ' + base + apiPath + '/refresh'
    }
  ]
}

const initPaymentBrand = (path, apiPath) => {
  initCRUD(path, apiPath)
  addExport(path, apiPath)
  addImport(path, apiPath)
}

const initPaymentSet = (path, apiPath) => {
  initEdit(path, apiPath)
  addExport(path, apiPath)
  let edit = editPath(path)
  permMap[edit] = [...permMap[edit],
    {
      'path': 'POST ' + base + apiPath + '/refresh/:id'
    }, {
      'path': 'DELETE ' + base + apiPath + '/:id'
    }, {
      'path': 'PUT ' + base + apiPath + '/:id/external'
    }, {
      'path': 'POST ' + base + apiPath + '/import'
    }, {
      'path': 'POST ' + base + apiPath + '/import_update'
    }
  ]
}

const initSOAInvoice = (path, apiPath) => {
  permMap[path] = [
    'view',
    'edit',
    'add'
  ]
  permMap[viewPath(path)] = [
    {
      'path': 'GET ' + base + apiPath
    }, {
      'path': 'GET ' + base + apiPath + '/:id'
    }, {
      'path': 'GET ' + base + apiPath + '/:id/editlog'
    }
  ]
  permMap[editPath(path)] = [
    {
      'path': 'PUT ' + base + apiPath + '/:id'
    }, {
      'path': 'PUT ' + base + apiPath + '/:id/void'
    }
  ]
  permMap[addPath(path)] = [
    {
      'path': 'POST ' + base + apiPath
    }
  ]
}

const initSOANote = (path, apiPath) => {
  permMap[path] = [
    'view',
    'edit',
    'add'
  ]
  permMap[viewPath(path)] = [
    {
      'path': 'GET ' + base + apiPath
    }, {
      'path': 'GET ' + base + apiPath + '/:id'
    }, {
      'path': 'GET ' + base + apiPath + '/:id/editlog'
    }
  ]
  permMap[editPath(path)] = [
    {
      'path': 'PUT ' + base + apiPath + '/:id'
    }, {
      'path': 'PUT ' + base + apiPath + '/:id/void'
    }
  ]
  permMap[addPath(path)] = [
    {
      'path': 'POST ' + base + apiPath
    }, {
      'path': 'POST ' + base + apiPath + '/edit-bookings'
    }
  ]
}

const initSOAReceipt = (path, apiPath) => {
  permMap[path] = [
    'view',
    'edit',
    'add'
  ]
  permMap[viewPath(path)] = [
    {
      'path': 'GET ' + base + apiPath
    }, {
      'path': 'GET ' + base + apiPath + '/:id'
    }, {
      'path': 'GET ' + base + apiPath + '/:id/editlog'
    }
  ]
  permMap[editPath(path)] = [
    {
      'path': 'PUT ' + base + apiPath + '/:id'
    }, {
      'path': 'PUT ' + base + apiPath + '/:id/void'
    }
  ]
  permMap[addPath(path)] = [
    {
      'path': 'POST ' + base + apiPath
    }, {
      'path': 'GET ' + base + apiPath + '/branch'
    }, {
      'path': 'GET ' + base + apiPath + '/doc'
    }
  ]
}

const initSOAEmail = (path, apiPath) => {
  initCRUD(path, apiPath)
  addSend(path, apiPath, '/send')
}

const initStatement = (path, apiPath) => {
  initCRUD(path, apiPath)
  addSend(path, apiPath, '/send_email')
  addExport(path, apiPath)
  addImport(path, apiPath)
  let edit = editPath(path)
  permMap[edit] = [...permMap[edit],
    {
      'path': 'POST ' + base + apiPath + '/refresh'
    }, {
      'path': 'POST ' + base + apiPath + '/multi'
    }
  ]
  permMap[path].splice(4, 0, 'batch')
  let batch = path + '/batch'
  permMap[batch] = [
    {
      'path': 'POST ' + base + apiPath + '/batch'
    }, {
      'path': 'GET ' + base + apiPath + '/batch/:id'
    }, {
      'path': 'PUT ' + base + apiPath + '/batch/:id/stop'
    }, {
      'path': 'POST ' + base + apiPath + '/zip-attaches'
    }, {
      'path': 'GET ' + base + apiPath + '/file/:id'
    }
  ]
}

const initStatementEmail = (path, apiPath) => {
  initCRUD(path, apiPath)
  addSend(path, apiPath, '/send')
}

const initStatementOrders = (path, apiPath) => {
  initView(path, apiPath)
  addExport(path, apiPath)
}

const initStatementOrdersBrand = (path, apiPath) => {
  initView(path, apiPath)
  addExport(path, apiPath)
}

const initStatementOrdersSet = (path, apiPath) => {
  initView(path, apiPath)
  addExport(path, apiPath)
}

const initPromo = (path, apiPath) => {
  initCRUD(path, apiPath)
  addTrans(path, apiPath)
  let view = viewPath(path)
  let add = addPath(path)
  permMap[view] = [...permMap[view],
    {
      'path': 'GET ' + base + apiPath + '_code_list'
    },
    {
      'path': 'GET ' + base + apiPath + '/list_for_campaign'
    }
  ]
  permMap[add] = [...permMap[add],
    {
      'path': 'POST ' + base + apiPath + '/:id/bulk'
    }
  ]
}

const initCampaign = (path, apiPath) => {
  initCRUD(path, apiPath)
  addImage(path, apiPath, 'product_cover_image')
  addImage(path, apiPath, 'product_album_image')
}

const initPromoCampaign = (path, apiPath) => {
  initCRUD(path, apiPath)
  addImage(path, apiPath, 'cover_image')
}

const initMemberMission = (path, apiPath) => {
  initCRUD(path, apiPath)
}
const initTask = (path, apiPath) => {
  initCRUD(path, apiPath)
  addImage(path, apiPath, 'cover_image')
}

const initBlog = (path, apiPath) => {
  initStatus(path, apiPath)
  addImage(path, apiPath, 'cover_image')
  addImage(path, apiPath, 'album_image')
  let view = viewPath(path)
  let edit = viewPath(path)
  permMap[view] = [...permMap[view],
    {
      'path': 'GET ' + base + apiPath + '_album'
    }, {
      'path': 'GET ' + base + apiPath + '_album/:id'
    }, {
      'path': 'GET ' + base + apiPath + '_album/:id/editlog'
    }
  ]
  permMap[edit] = [...permMap[edit],
    {
      'path': 'PUT ' + base + apiPath + '_album/:id'
    }, {
      'path': 'DELETE ' + base + apiPath + '_album/:id'
    }
  ]
}

const initBlogAuthor = (path, apiPath) => {
  initCRUD(path, apiPath)
  addImage(path, apiPath, 'avatar')
}

const initBlogCountry = (path, apiPath) => {
  initStatus(path, apiPath)
  addTrans(path, apiPath)
}

const initBlogCategory = (path, apiPath) => {
  initCRUD(path, apiPath)
  addTrans(path, apiPath)
  addImage(path, apiPath, 'cover_image')
}

const initNews = (path, apiPath) => {
  initCRUD(path, apiPath)
  addTrans(path, apiPath)
  addImage(path, apiPath, 'image')
}

const initReceipt = (path, apiPath) => {
  initCRUD(path, apiPath)
  addSend(path, apiPath, '/send')
}

const initOrders = (path, apiPath) => {
  permMap[path] = [
    'view',
    'refund',
    'reschedule',
    'update',
    'cert',
    'notify',
    'review',
    'capture',
    'penalty'
  ]
  permMap[viewPath(path)] = [
    {
      'path': 'GET ' + base + apiPath
    }, {
      'path': 'GET ' + base + apiPath + '/:id'
    }, {
      'path': 'GET ' + base + apiPath + '/:id/editlog'
    }, {
      'path': 'GET ' + base + apiPath + '/editlog/:id'
    }, {
      'path': 'GET ' + base + apiPath + '/:id/promo'
    }, {
      'path': 'GET ' + base + apiPath + '_review'
    }
  ]
  permMap[path + '/refund'] = [
    {
      'path': 'POST ' + base + '/refund'
    }, {
      'path': 'GET ' + base + apiPath + '/:id/refund_amount'
    }
  ]
  permMap[path + '/reschedule'] = [
    {
      'path': 'PUT ' + base + apiPath + '/:id/bookingtime'
    }
  ]
  permMap[path + '/update'] = [
    {
      'path': 'PUT ' + base + apiPath + '/:id'
    }, {
      'path': 'GET ' + base + apiPath + '/:id/arrival_time'
    }, {
      'path': 'PUT ' + base + apiPath + '/:id/note'
    }
  ]
  permMap[path + '/cert'] = [
    {
      'path': 'POST ' + base + apiPath + '/:id/cert'
    }, {
      'path': 'DELETE ' + base + apiPath + '/:cert_id/cert'
    }
  ]
  permMap[path + '/notify'] = [
    {
      'path': 'GET ' + base + apiPath + '/:id/attendee_link'
    }, {
      'path': 'POST ' + base + apiPath + '/orders_notify'
    }
  ]
  permMap[path + '/review'] = [
    {
      'path': 'PUT ' + base + apiPath + '_review/:review_id'
    }, {
      'path': 'DELETE ' + base + apiPath + '_review/:review_id'
    }
  ]
  permMap[path + '/capture'] = [
    {
      'path': 'POST ' + base + apiPath + '/:id/capture'
    }
  ]
  permMap[path + '/penalty'] = [
    {
      'path': 'GET ' + base + apiPath + '/:id/penalty'
    }, {
      'path': 'POST ' + base + apiPath + '/:id/penalty'
    }, {
      'path': 'GET ' + base + apiPath + '/:id/penalty/txn'
    }
  ]
}

const initInvoice = (path, apiPath) => {
  permMap[path] = [
    'view',
    'invoice'
  ]
  permMap[viewPath(path)] = [
    {
      'path': 'GET ' + base + apiPath
    }, {
      'path': 'GET ' + base + apiPath + '/:id'
    }, {
      'path': 'GET ' + base + apiPath + '_allow'
    }, {
      'path': 'GET ' + base + apiPath + '_allow/:id'
    }
  ]
  permMap[path + '/invoice'] = [
    {
      'path': 'POST ' + base + apiPath
    }, {
      'path': 'POST ' + base + apiPath + '/auto'
    }, {
      'path': 'PUT ' + base + apiPath + '/:id/invalid'
    }, {
      'path': 'PUT ' + base + apiPath + '/:id/allow'
    }, {
      'path': 'PUT ' + base + apiPath + '_allow/:id/invalid'
    }
  ]
}

const initGiftCard = (path, apiPath) => {
  initStatus(path, apiPath)
  addImage(path, apiPath, 'image')
}

const initRemark = (path, apiPath) => {
  initCRUD(path, apiPath)
  addTrans(path, apiPath)
  addImage(path, apiPath, 'content_image')
}

const initMerchant = (path, apiPath) => {
  initStatus(path, apiPath)
}

const initBranch = (path, apiPath) => {
  initStatus(path, apiPath)
  addTrans(path, apiPath)
  addImage(path, apiPath, 'cover_image')
  let view = viewPath(path)
  let edit = editPath(path)
  permMap[view] = [...permMap[view],
    {
      'path': 'GET ' + base + apiPath + '/:id/inline_rsc'
    }, {
      'path': 'GET ' + base + '/coverfee/:id/editlog'
    }
  ]
  permMap[edit] = [...permMap[edit],
    {
      'path': 'POST ' + base + '/user/bossnow/branch'
    }, {
      'path': 'DELETE ' + base + '/user/bossnow/:id/branch/:bid'
    }, {
      'path': 'PUT ' + base + apiPath + '/:id/line_spot'
    }, {
      'path': 'PUT ' + base + '/contract/:id/exp'
    }, {
      'path': 'POST ' + base + apiPath + '/channel'
    }, {
      'path': 'DELETE ' + base + apiPath + '/channel/:map_id'
    }, {
      'path': 'POST ' + base + '/coverfee'
    }, {
      'path': 'PUT ' + base + '/coverfee/:id'
    }, {
      'path': 'DELETE ' + base + '/coverfee/:id'
    }
  ]

  permMap[path].splice(2, 0, 'edit_invoice')
  permMap[path + '/edit_invoice'] = [
    {
      'path': 'PUT ' + base + apiPath + '/:id/invoice'
    }
  ]

  permMap[path].push('aos')
  const aosPath = base + '/aos'
  const aosBUPath = aosPath + '/branch/:bid/brand/:brand_id'
  const aosFormPath = aosBUPath + '/form'
  const branchBUPath = base + apiPath + '/:id/brand/:brand_id'
  permMap[path + '/aos'] = [
    {
      'path': 'GET ' + aosFormPath
    }, {
      'path': 'PUT ' + aosFormPath
    }, {
      'path': 'POST ' + aosFormPath + '/submit'
    }, {
      'path': 'POST ' + aosFormPath + '/review'
    }, {
      'path': 'POST ' + aosFormPath + '/sync'
    }, {
      'path': 'POST ' + branchBUPath + '/go_live_email'
    }, {
      'path': 'GET ' + aosPath + '/channel'
    }, {
      'path': 'GET ' + aosPath + '/manager'
    }, {
      'path': 'GET ' + aosPath + '/region'
    }, {
      'path': 'GET ' + aosPath + '/industry'
    }, {
      'path': 'GET ' + aosPath + '/tag/available'
    }, {
      'path': 'GET ' + aosBUPath + '/room_type'
    }, {
      'path': 'POST ' + aosBUPath + '/room_type'
    }, {
      'path': 'PUT ' + aosBUPath + '/room_type/:room_type_id'
    }, {
      'path': 'GET ' + aosBUPath + '/product_remark'
    }
  ]
}

const initProduct = (path, apiPath) => {
  initStatus(path, apiPath)
  addTrans(path, apiPath)
  addImage(path, apiPath, 'cover_image')
  addImage(path, apiPath, 'album_image')
  let view = viewPath(path)
  let edit = editPath(path)
  let fullPath = base + apiPath
  permMap[view] = [...permMap[view],
    {
      'path': 'GET ' + fullPath + '/:id/cancel_rule'
    }, {
      'path': 'GET ' + fullPath + '/:id/reschedule_rule'
    }, {
      'path': 'GET ' + fullPath + '/:id/inline_rsc'
    }
  ]
  permMap[edit] = [...permMap[edit],
    {
      'path': 'PUT ' + fullPath + '/:id/album_image'
    }, {
      'path': 'DELETE ' + fullPath + '/:id/album_image'
    }, {
      'path': 'POST ' + fullPath + '/intro_image'
    }, {
      'path': 'PUT ' + fullPath + '/:id/line_spot'
    }, {
      'path': 'POST ' + fullPath + '/partner'
    }, {
      'path': 'POST ' + fullPath + '/partner/:partner_id/upload'
    }, {
      'path': 'PUT ' + fullPath + '/partner/:product_partner_id'
    }, {
      'path': 'POST ' + fullPath + '/channel'
    }, {
      'path': 'DELETE ' + fullPath + '/channel/:map_id'
    }, {
      'path': 'POST ' + fullPath + '/orders_notify'
    }
  ]

  permMap[path].splice(2, 0, 'edit_payment')
  permMap[path + '/edit_payment'] = [
    {
      'path': 'PUT ' + fullPath + '/:id/payment'
    }, {
      'path': 'POST ' + fullPath + '/cover_fee'
    }, {
      'path': 'PUT ' + fullPath + '/cover_fee/:id'
    }, {
      'path': 'DELETE ' + fullPath + '/cover_fee/:id'
    }
  ]
}

const initUpgrade = (path, apiPath) => {
  initCRUD(path, apiPath)
  addTrans(path, apiPath)
}

const initCurrency = (path, apiPath) => {
  initCRUD(path, apiPath)
  addTrans(path, apiPath)
}

const initRegion = (path, apiPath) => {
  initStatus(path, apiPath)
  addTrans(path, apiPath)
  addImage(path, apiPath, 'cover_image')
  addImage(path, apiPath, 'web_image')
  let edit = editPath(path)
  permMap[edit] = [...permMap[edit],
    {
      'path': 'POST ' + base + '/user/bossnow/region'
    }, {
      'path': 'DELETE ' + base + '/user/bossnow/:id/region/:map_id'
    }
  ]
}

const initCategory = (path, apiPath) => {
  initStatus(path, apiPath)
  addTrans(path, apiPath)
  addImage(path, apiPath, 'cover_image')
  addImage(path, apiPath, 'banner_image')
  addImage(path, apiPath, 'icon_image')
  addImage(path, apiPath, 'map_icon_image')
  let view = viewPath(path)
  permMap[view] = [...permMap[view],
    {
      'path': 'GET ' + base + '/group_category'
    }, {
      'path': 'GET ' + base + '/hotarea'
    }
  ]
}

const initFilter = (path, apiPath) => {
  initCRUD(path, apiPath)
  addTrans(path, apiPath)
}

const initTag = (path, apiPath) => {
  initCRUD(path, apiPath)
  addTrans(path, apiPath)
  addImage(path, apiPath, 'cover_image')
}

const initBanner = (path, apiPath) => {
  initStatus(path, apiPath)
  addTrans(path, apiPath)
  addImage(path, apiPath, 'cover_image')
  addImage(path, apiPath, 'large_cover_image')
}

const initEventNews = (path, apiPath) => {
  initStatus(path, apiPath)
  addTrans(path, apiPath)
  addImage(path, apiPath, 'cover_image')
}

const initHotSearch = (path, apiPath) => {
  initCRUD(path, apiPath)
  addTrans(path, apiPath)
}

const initAdminUser = (path, apiPath) => {
  initStatus(path, apiPath)
  let view = viewPath(path)
  let edit = editPath(path)
  permMap[view] = [...permMap[view],
    {
      'path': 'GET ' + base + apiPath + '/:id/mfa'
    }, {
      'path': 'GET ' + base + apiPath + '_auth'
    }, {
      'path': 'GET ' + base + apiPath + '_auth/:id'
    }
  ]
  permMap[edit] = [...permMap[edit],
    {
      'path': 'PUT ' + base + apiPath + '/:id/mfa'
    }, {
      'path': 'PUT ' + base + apiPath + '/:id/metabase_token'
    }, {
      'path': 'POST ' + base + apiPath + '_auth/:uid'
    }, {
      'path': 'PUT ' + base + apiPath + '_auth/id/:id'
    }, {
      'path': 'PUT ' + base + apiPath + '_auth/token/:id'
    }, {
      'path': 'DELETE ' + base + apiPath + '_auth/:id'
    }, {
      'path': 'POST ' + base + apiPath + '/user_role'
    }, {
      'path': 'DELETE ' + base + apiPath + '/user_role/:id'
    }
  ]
}

const initManager = (path, apiPath) => {
  initStatus(path, apiPath)
  let view = viewPath(path)
  let edit = editPath(path)
  permMap[view] = [...permMap[view],
    {
      'path': 'GET ' + base + apiPath + '_auth'
    }, {
      'path': 'GET ' + base + apiPath + '_auth/:id'
    }
  ]
  permMap[edit] = [...permMap[edit],
    {
      'path': 'POST ' + base + apiPath + '_auth/:uid'
    }, {
      'path': 'PUT ' + base + apiPath + '_auth/id/:id'
    }, {
      'path': 'PUT ' + base + apiPath + '_auth/token/:id'
    }, {
      'path': 'DELETE ' + base + apiPath + '_auth/:id'
    }
  ]
}

const initMember = (path, apiPath) => {
  permMap[path] = [
    'view',
    'edit',
    'delete'
  ]
  let view = viewPath(path)
  permMap[view] = [
    {
      'path': 'GET ' + base + apiPath
    }, {
      'path': 'GET ' + base + apiPath + '/:id'
    }, {
      'path': 'GET ' + base + apiPath + '/:id/editlog'
    }, {
      'path': 'GET ' + base + apiPath + '_auth'
    }, {
      'path': 'GET ' + base + apiPath + '_auth/:id'
    }
  ]
  permMap[editPath(path)] = [
    {
      'path': 'PUT ' + base + apiPath + '/:id'
    }, {
      'path': 'PUT ' + base + apiPath + '/:id/status'
    }, {
      'path': 'PUT ' + base + apiPath + '/:id/deletion'
    }, {
      'path': 'POST ' + base + apiPath + '_auth/:uid'
    }, {
      'path': 'PUT ' + base + apiPath + '_auth/id/:id'
    }, {
      'path': 'PUT ' + base + apiPath + '_auth/token/:id'
    }, {
      'path': 'DELETE ' + base + apiPath + '_auth/:id'
    }
  ]
  permMap[deletePath(path)] = [
    {
      'path': 'DELETE ' + base + apiPath + '/:id'
    }
  ]

  if (apiPath === '/user/eatigo') {
    permMap[view] = [...permMap[view],
      {
        'path': 'GET ' + base + apiPath + '/:id/attendance-history'
      }, {
        'path': 'GET ' + base + apiPath + '/:id/attendance-history-score'
      }
    ]
  }
}

const initCRUD = (path, apiPath) => {
  permMap[path] = [
    'view',
    'edit',
    'add',
    'delete'
  ]
  permMap[viewPath(path)] = [
    {
      'path': 'GET ' + base + apiPath
    }, {
      'path': 'GET ' + base + apiPath + '/:id'
    }, {
      'path': 'GET ' + base + apiPath + '/:id/editlog'
    }
  ]
  permMap[editPath(path)] = [
    {
      'path': 'PUT ' + base + apiPath + '/:id'
    }
  ]
  permMap[addPath(path)] = [
    {
      'path': 'POST ' + base + apiPath
    }
  ]
  permMap[deletePath(path)] = [
    {
      'path': 'DELETE ' + base + apiPath + '/:id'
    }
  ]
}

const initStatus = (path, apiPath) => {
  initCRUD(path, apiPath)
  let edit = editPath(path)
  permMap[edit] = [...permMap[edit],
    {
      'path': 'PUT ' + base + apiPath + '/:id/status'
    }
  ]
}

const initList = (path, apiPath) => {
  permMap[path] = [
    'view'
  ]
  permMap[viewPath(path)] = [
    {
      'path': 'GET ' + base + apiPath
    }
  ]
}

const initView = (path, apiPath) => {
  permMap[path] = [
    'view'
  ]
  permMap[viewPath(path)] = [
    {
      'path': 'GET ' + base + apiPath
    }, {
      'path': 'GET ' + base + apiPath + '/:id'
    }
  ]
}

const initEdit = (path, apiPath) => {
  permMap[path] = [
    'view',
    'edit'
  ]
  permMap[viewPath(path)] = [
    {
      'path': 'GET ' + base + apiPath
    }, {
      'path': 'GET ' + base + apiPath + '/:id'
    }, {
      'path': 'GET ' + base + apiPath + '/:id/editlog'
    }
  ]
  permMap[editPath(path)] = [
    {
      'path': 'PUT ' + base + apiPath + '/:id'
    }
  ]
}

const addImage = (path, apiPath, name) => {
  let add = addPath(path)
  let edit = editPath(path)
  permMap[add] = [...permMap[add],
    {
      'path': 'POST ' + base + apiPath + '/' + name
    }
  ]
  permMap[edit] = [...permMap[edit],
    {
      'path': 'POST ' + base + apiPath + '/' + name + '/:id'
    }
  ]
}

const addTrans = (path, apiPath) => {
  let view = viewPath(path)
  let edit = editPath(path)
  permMap[view] = [...permMap[view],
    {
      'path': 'GET ' + base + apiPath + '_trans'
    }, {
      'path': 'GET ' + base + apiPath + '_trans/:id'
    }
  ]
  permMap[edit] = [...permMap[edit],
    {
      'path': 'POST ' + base + apiPath + '_trans'
    }, {
      'path': 'PUT ' + base + apiPath + '_trans/:id'
    }, {
      'path': 'DELETE ' + base + apiPath + '_trans/:id'
    }
  ]
}

const addExport = (path, apiPath) => {
  let view = viewPath(path)
  permMap[view] = [...permMap[view],
    {
      'path': 'GET ' + base + apiPath + '/:id/fields'
    }, {
      'path': 'POST ' + base + apiPath + '/export'
    }
  ]
}

const addImport = (path, apiPath) => {
  let add = addPath(path)
  permMap[add] = [...permMap[add],
    {
      'path': 'POST ' + base + apiPath + '/import'
    }
  ]
}

const addSend = (path, apiPath, subPath) => {
  permMap[path].splice(1, 0, 'send')
  permMap[sendPath(path)] = [
    {
      'path': 'POST ' + base + apiPath + subPath
    }
  ]
}
